import { DriverFiltersProps } from "@/lib/drivers/types"
const categories = [
  { value: "", label: "Category" },
  { value: "pets-and-animals", label: "Pets and Animals" },
  { value: "motorcycles", label: "Motorcycles" },
  { value: "vehicles", label: "Vehicles" },
  { value: "boats-and-water-vehicles", label: "Boats and Water Vehicles" },
  { value: "household-items", label: "Household items" },
  { value: "apartment-and-home-moves", label: "Apartment and home moves" },
  {
    value: "heavy-equipment-and-industrial",
    label: "Heavy equipment and industrial",
  },
  { value: "freight", label: "Freight" },
  { value: "all-other-items", label: "All other items" },
]
function ShipmentCategorySelect({
  searchParams,
  handleFilterChange,
}: {
  searchParams: DriverFiltersProps["searchParams"]
  handleFilterChange: Function
}) {
  const selectedCategory = searchParams?.shipmentCategories ?? ""
  return (
    <div>
      <h3 className="font-medium mb-2">Mostly Delivers</h3>
      <select
        className="w-full p-2 border rounded"
        value={selectedCategory}
        onChange={(e) =>
          handleFilterChange("shipmentCategories", e.target.value)
        }
      >
        {categories.map((category) => (
          <option key={category.value} value={category.value}>
            {category.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default ShipmentCategorySelect
